/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React, {RefObject} from 'react';
import {Button, Dialog, TextInput, Toolbar, ToolbarSpacer} from "@ice/components";
import {getAppComponent} from "../store/Accessor";
import {$t} from "../lang/LangUtil";
import {FormContainer} from "./FormContainer";


interface QuestionDialogProps {
    title: string;
    text: string;
    onConfirm: () => void;
}


interface QuestionDialogState {
}


export class QuestionDialog extends React.Component<QuestionDialogProps, QuestionDialogState> {

    constructor(props: QuestionDialogProps) {
        super(props);
        this.state = {}
    }

    private close = () => {
        getAppComponent().hideDialog();
    }

    private confirm = () => {
        this.props.onConfirm();
    }

    render = () => {
        return (
            <Dialog
                onClose={this.close}
                title={this.props.title}
                closeControl={true}
                modal={true}
            >
                <div css={css`width: 34rem; overflow: hidden; padding: 1rem`}>
                    <FormContainer>
                        <div>
                            {this.props.text}
                        </div>
                        <Toolbar bordered={false}>
                            <ToolbarSpacer />
                            <Button autoFocus onClick={this.close}>{$t("no")}</Button>
                            <Button onClick={this.confirm} intent="primary">{$t("yes")}</Button>
                        </Toolbar>
                    </FormContainer>
                </div>
            </Dialog>
        );
    }

}
